import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { isInfiniteScroll } from "../config"

// Classic / pagination body: shows a full loader while (re)loading, then the
// grid + pagination controls. Unchanged from the original behaviour.
export function CategoryBodyPaginated({ loading, foundProducts }) {
    if (loading) return <Loader />

    return (
        foundProducts ? <>
            <Products />
            <BottomToolbar />
        </> : <NoResults />
    )
}

// Infinite (button-only load more) body: only shows the full loader on the very
// first load (no products yet). Once products exist, we keep <Products> mounted
// even while a load-more request is in flight — otherwise the grid would be
// swapped for a loader, collapse to zero height, and the page would jump.
// <Products> renders its own "Load more" button (button-only, no auto-scroll).
export function CategoryBodyInfinite({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <Products />
        </>
    )
}

// Pick the body based on the browsing mode setting (window.pgpBrowsing.mode,
// only active under the new layout). Falls back to the classic paginated body.
const CategoryBody = isInfiniteScroll ? CategoryBodyInfinite : CategoryBodyPaginated

export default wrapContent("category", CategoryBody)
